import Vue from 'vue';
import store from "../store";
import VueAMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '878713f1cfe4a6bbec93b91867159c2f',
  // 旧 878713f1cfe4a6bbec93b91867159c2f   新 9433f67fbab2dada21e7e54db9f7bffc
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
lazyAMapApiLoaderInstance.load().then(function () {
  store.state.settings.amapSign = true;
});